export default function(){
    return(
        <section className="case-details-area pt-115 pb-55 pt-md-55 pb-md-30 pt-xs-40 pb-xs-30">
				<div className="container">
					<div className="row">
						<div className="col-xl-9 col-lg-8 col-md-12">
							<div className="case-details-wrapper mb-30">
								<h3 className="case-detail-title">Future is brighter when you’re more prepared</h3>
								<p>We are increases exponentially. Today banks and other financial organizations face the
									need of providing the best possible
									services in the best possible way and reachable by everyone everywhere. We are watching
									to a spread of different products
									and services being available through the use.</p>
								<img className="big-img w-100 mt-45" src="assets/img/portfolio/pr-16.jpg" alt="Img" />
								<div className="letter-box">
									<div className="a-tag mb-15">
										a
									</div>
									<p className="mb-15">A recognizable and loved brand is one of the most valuable assets a
										company owns. In fact, 59% of customers
										prefer to buy products from brands they know. How do you become a sought-after brand
										with endless sales and
										raving fans? By identifying your promise to a customer or client.</p>
								</div>
								<p className="mb-30">This shortage is being seen in both the airline and the cargo industries.
									With such a
									small pool of applicants to choose from,
									these two sectors are <b className="text-heding">battling</b> to get the most qualified
									available candidates. Many pilots are increasingly being wooed to get
									behind the controls of passenger planes over cargo flights—frankly, it’s tough to
									compete with jobs perks like fixed schedules &
									free flights for your family across the world. This is no anecdotal pilot shortage,
									either—the same problems are found on a global
									scale, with Boeing estimating an incredible shortage of <b
										className="text-heding">790,000</b> or more pilots across
									the world over the next two decades. In
									the shorter term, the domestic industry can expect more than <b
										className="text-heding">8,000.</b></p>
								<h5 className="med-text fs-20 fw-medium">Unfilled vacancies per year by 2020, and five years
									later that
									number could be higher than 12,000
									pilot-less flights in need of help.</h5>
								<div className="row mb-20">
									<div className="col-lg-4 col-md-4 mb-30">
										<img className="w-100 cs-img" src="assets/img/portfolio/pr-17.jpg" alt="Img" />
									</div>
									<div className="col-lg-4 col-md-4 mb-30">
										<img className="w-100 cs-img" src="assets/img/portfolio/pr-18.jpg" alt="Img" />
									</div>
									<div className="col-lg-4 col-md-4 mb-30">
										<img className="w-100 cs-img" src="assets/img/portfolio/pr-19.jpg" alt="Img" />
									</div>
								</div>
								<p>Known as an IT managed services provider, an IT support company is comprised of
									professional IT specialists who make up the
									company's core IT team. The team provides your. business with expert guidance and
									management for a variety of information
									technology needs. A solution is an implementation of people, processes, information and
									technologies in a distinct system to
									support a set of business or technical capabilities that solve one or more business
									problems.</p>
								<div className="row mb-25 mt-55">
									<div className="col-lg-6 col-md-6">
										<div className="vision-wrapper mb-30">
											<h5 className="fs-20">01. Our Mission</h5>
											<p>Services is a general term that describes work that supports
												a business but does not produce a tangible commodity. ... A
												good business service aligns IT assets with the needs of a
												company's employees and customers and support business
												goals, facilitating the ability of the company.</p>
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className="vision-wrapper mb-30">
											<h5 className="fs-20">02. Our Challange</h5>
											<p>Services is a general term that describes work that supports
												a business but does not produce a tangible commodity. ... A
												good business service aligns IT assets with the needs of a
												company's employees and customers and support business
												goals, facilitating the ability of the company.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-12">
							<div className="case-widget-sidebar mb-30">
								<div className="project-details-widget mb-40">
									<h5 className="case-widget-title lh-1 mb-15">Project Details</h5>
									<ul className="project-info list-none">
										<li><b>Category:</b> Digital Marketing</li>
										<li><b>Client:</b> Alonso Dicosa</li>
										<li><b>Values:</b> $20,000</li>
									</ul>
									<a className="theme_btn theme_btn3" href="portfolio.html">Live Preview <i
											className="fal fa-long-arrow-right"></i></a>
								</div>
								<div className="get-update">
									<h5 className="case-widget-title lh-1 mb-30">Get A Quote</h5>
									<form className="row gx-0 contact-form mb-30">
										<div className="col-xl-12">
											<div className="input-box mb-20">
												<input type="text" placeholder="Full name" />
											</div>
										</div>
										<div className="col-xl-12">
											<div className="input-box mail-input mb-20">
												<input type="email" placeholder="Email address" />
											</div>
										</div>
										<div className="col-xl-12 mb-20">
											<div className="inquiry">
												<div className="input-box sub-input">
													<input type="text" placeholder="Subject" />
												</div>
											</div>
										</div>
										<div className="col-xl-12">
											<div className="input-box text-input mb-15">
												<textarea name="message" cols="30" rows="10"
													placeholder="Enter massge"></textarea>
											</div>
										</div>
										<button type="submit" className="form-btn form-btn3">Get A Quote</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
    )
}